import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';
import { HttpParams } from '@angular/common/http';
import { BilledFilter } from 'src/app/shared/models/billedFilter.model';

@Injectable({ providedIn: 'root' })
export class BilledService {
    constructor(private dataService: DataService) { }

    public get(page: number, order: string, orderT: string, filter: BilledFilter) {
        let params = new HttpParams()
            .set('filter.page', page.toString())
            .set('filter.entity.pac', filter.pac || '')
            .set('filter.entity.negId', filter.negId)
            .set('filter.entity.negRef', filter.negRef || '')
            .set('filter.entity.client', filter.clientId)
            .set('filter.entity.popId', filter.popId)
            .set('filter.entity.id', filter.id)
            .set('filter.orderByField', order)
            .set('filter.orderBy', orderT);

        return this.dataService.get<Result<any>>("request/billed", params);
    }
}
